import { Grid, TextField } from "@mui/material";
import { t } from "i18next";

function UserTableSearch({ setFormData, formData }) {
  const { search } = formData;

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <Grid item md={5} xs={12}>
        <TextField id="username" label={t("user.user_id")} variant="outlined"
                   value={search} fullWidth
                   onChange={(e) => handleChange("search", e.target.value)}
        />
      </Grid>
      <Grid item md={4} xs={0} />
    </>
  );
}

export default UserTableSearch;
